<template>
  <v-dialog persistent v-model="show" max-width="500px">
    <v-card ref="form">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Manage User</h3>
        </div>
      </v-card-title>

      <v-card-text>

        <v-text-field
          ref="realname"
          v-model="realname"
          :rules="[() => !!realname || 'This field is required']"
          :error-messages="errorMessages"
          label="Full Name"
          placeholder="John Doe"
          required
        ></v-text-field>

        <v-list
          subheader
          three-line
        >
          <v-subheader>Permissions</v-subheader>

          <template v-for="(item, index) in permissions">

            <v-list-tile @click="">
              <v-list-tile-action>
                <v-switch v-model="item.hasPermission"></v-switch>
              </v-list-tile-action>

              <v-list-tile-content @click="notifications = !notifications">
                <v-list-tile-title>{{item.name}}</v-list-tile-title>
                <v-list-tile-sub-title>{{item.description}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

          </template>

        </v-list>

      </v-card-text>

      <v-divider class="mt-5"></v-divider>

      <v-card-actions>
        <v-btn flat @click.stop="show=false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-slide-x-reverse-transition>
          <v-tooltip
            v-if="formHasErrors"
            left
          >
            <v-btn
              slot="activator"
              icon
              class="my-0"
              @click="resetForm"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh form</span>
          </v-tooltip>
        </v-slide-x-reverse-transition>
        <v-btn flat @click="updateUser">Update</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import generator from 'generate-password'

  export default {
    name: "CreateUserDialog",
    props: {
      userData: {},
      visible: {
        type: Boolean
      }
    },
    data() {
      return {
        formHasErrors: false,
        realname: '',
        username: '',
        errorMessages: [],
        permissions: []
      }
    },
    computed: {

      form() {
        return {
          realname: this.realname,
          username: this.username
        }
      },
      show: {
        get() {
          return this.visible
        },
        set(value) {
          if (!value) {
            this.$emit('close')
          }
        }
      }
    },
    methods: {
      editUser(name) {
        console.log('EDIT USER ' + name)
      },
      close() {
        this.dialog = false
        this.userItem = {
          realname: '',
          username: '',
          password: '',
          role: ''
        }
      },
      save() {
        var userToCreate = this.userItem

        this.close()
      },
      loadUserList() {
        this.$emit('updateUserList')
      },
      updateUser() {
        var userData = JSON.parse(JSON.stringify(this.userData));
        var id = userData._id;
        var userDataRuleset = [];

        console.log(this.permissions);

        this.permissions.forEach((permission) => {
          if (permission.hasPermission) {
            userDataRuleset.push(permission._id);
          }
        })

        userData.rules = userDataRuleset;

        //Remove unneeded fields before pushing to server
        delete userData._id;
        delete userData.__v;

        userData.local.realname = this.realname;

        var updateObject = {
          id: id,
          updateObject: userData
        }

        console.log(JSON.stringify(updateObject))

        this.$http.post('/panel/user/update', updateObject, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            if (response.data.success) {
              this.$emit('updated')
              this.show = false;
            } else {
              this.$root.$emit('snackbar', response.data.msg)
            }

          })
          .catch(e => {
            // console.log(JSON.stringify(e));
            this.$root.$emit('snackbar', e.response.data.msg)
          })
      },
      createUser() {
        this.formHasErrors = false

        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) this.formHasErrors = true

          this.$refs[f].validate(true)
        })

        if (!this.realname || !this.username) {
          this.$root.$emit('snackbar', "Fields cannot be empty!")
          return;
        }
        var password = generator.generate({length: 8, numbers: true})

        var userObj = {username: this.username, realname: this.realname, password: password}

        this.$http.post('/auth/register', userObj, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            if (response.data.success) {
              this.createdUserName = this.username;
              this.createdRealName = this.realname;
              this.createdPassword = password

              this.username = '';
              this.realname = '';

              this.userCreated = true;
            } else {
              this.$root.$emit('snackbar', response.data.msg)
            }

          })
          .catch(e => {
            // console.log(JSON.stringify(e));
            this.$root.$emit('snackbar', e.response.data.msg)
          })
      },
      resetForm() {
        this.errorMessages = []
        this.formHasErrors = false

        Object.keys(this.form).forEach(f => {
          this.$refs[f].reset()
        })
      },
      getPermissionList() {
        this.$http.get('/panel/permissions', {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {

            if (response.data) {
              this.permissions = response.data;

              this.permissions.forEach((permission) => {
                var id = permission._id;

                permission.hasPermission = false;

                this.userData.rules.forEach((rule) => {
                  var id2 = rule._id;

                  if (id == id2) {
                    permission.hasPermission = true;
                  }
                })
              })

              console.log(this.userData.rules);
            } else {
              this.$root.$emit('snackbar', response.data.msg)
            }

          })
          .catch(e => {
            // console.log(JSON.stringify(e));
            this.$root.$emit('snackbar', e.response.data.msg)
          })
      }
    },
    watch: {
      visible: function (newState, oldState) {
        console.log(newState);
        console.log(this.userData);

        if (newState) {
          try {
            this.realname = this.userData.local.realname;
            this.getPermissionList();
          } catch (e) {

          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/ManageUserDialog.vue